import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { titleStyle } from './documentCell.css';

type Props = {
  name: string;
};

export const DocumentNameCell = ({ name }: Props) => {
  return <span className={clsx(desktopTruncateStyle, titleStyle)}>{name}</span>;
};
